import * as React from 'react';
import CompleteOrderPageViewDate from '../layouts/CompleteOrderPageViewDate';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
// import { UserDetail } from '../../reducers/user';

export interface CompleteOrderPageDateViewProps {
    onComponentDidMount: () => void;
    completeOrderDataDate: RowDataCompleted[];
    completeOrderDataExport: RowDataCompleted[];
    isDownloading: boolean;
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => void;
    onBulkDownloadIndividual: () => void;
    // onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    fDate: (fromDate: Date | null) => void;
    fTime: (fromTime: Date | null) => void;
    toDate: (todate: Date | null) => void;
    toTime: (toTime: Date | null) => void;

    startDate: Date | null;
    endDate: Date | null;
    startTime: Date | null;
    endTime: Date | null;

    dateFilter: () => void;
    dateReset: () => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
    // Add missing props here
    failedFiles: Array<{ fname: string; orderno: string }>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
    closeFailedFilesDialog: () => void;   
}

class CompleteOrderPageDate extends React.Component<CompleteOrderPageDateViewProps> {
    render() {
        return (
            <CompleteOrderPageViewDate
                completeOrderDataDate={this.props.completeOrderDataDate}
                completeOrderDataExport={this.props.completeOrderDataExport}
                isDownloading={this.props.isDownloading}
                reload={this.props.reload}
                onRowClick={this.props.onRowClick}
                onDownloadClick={this.props.onDownloadClick}
                onBulkDownload={this.props.onBulkDownload}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                fDate={this.props.fDate}
                fTime={this.props.fTime}
                toDate={this.props.toDate}
                toTime={this.props.toTime}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                startTime={this.props.startTime}
                endTime={this.props.endTime}
                dateFilter={this.props.dateFilter}
                dateReset={this.props.dateReset}
                openVideoPlayerURL={this.props.openVideoPlayerURL}
                onBulkDownloadIndividual={this.props.onBulkDownloadIndividual}
                // Add these new props
                failedFiles={this.props.failedFiles}
                showFailedFilesDialog={this.props.showFailedFilesDialog}
                failedFilesMessage={this.props.failedFilesMessage}
                closeFailedFilesDialog={this.props.closeFailedFilesDialog}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
}

export default CompleteOrderPageDate;



// WEBPACK FOOTER //
// ./src/components/CompletedOrderPageDate/CompletedOrderPageDate.tsx